import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios'; // Material UI

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import makeStyles from '@material-ui/core/styles/makeStyles'; // Material UI Icons

import DialogIcon from '@material-ui/icons/ErrorOutline';
import LogoutIcon from '@material-ui/icons/ExitToApp';
var useStyles = makeStyles(function (_theme) {
  return {
    span: {
      display: 'flex',
      alignItems: 'center'
    },
    icon: {
      marginRight: 15,
      marginTop: -2,
      color: 'steelblue'
    },
    buttonTextUpper: {
      textTransform: 'uppercase'
    },
    buttonTextLower: {
      textTransform: 'unset'
    }
  };
});
export var Logout = function Logout(_ref) {
  var iconSize = _ref.iconSize,
      isLogoutOpen = _ref.isLogoutOpen,
      setLogoutOpen = _ref.setLogoutOpen,
      showIcon = _ref.showIcon,
      textCaseUpper = _ref.textCaseUpper;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    className: textCaseUpper ? classes.buttonTextUpper : classes.buttonTextLower,
    color: "inherit",
    size: iconSize || 'large',
    startIcon: showIcon ? /*#__PURE__*/React.createElement(LogoutIcon, null) : null,
    onClick: function onClick() {
      return setLogoutOpen(true);
    }
  }, "Logout"), /*#__PURE__*/React.createElement(Dialog, {
    "aria-describedby": "alert-dialog-description",
    "aria-labelledby": "alert-dialog-title",
    disableEscapeKeyDown: true,
    open: isLogoutOpen,
    onClose: function onClose() {
      return setLogoutOpen(false);
    }
  }, /*#__PURE__*/React.createElement(DialogTitle, {
    id: "alert-dialog-title"
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.span
  }, /*#__PURE__*/React.createElement(DialogIcon, {
    className: classes.icon
  }), "Logout")), /*#__PURE__*/React.createElement(DialogContent, null, /*#__PURE__*/React.createElement(DialogContentText, {
    id: "alert-dialog-description"
  }, "Are you sure you want to logout?")), /*#__PURE__*/React.createElement(DialogActions, null, /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    onClick: function onClick() {
      return setLogoutOpen(false);
    }
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    onClick: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              localStorage.removeItem('sessionExpireTime');
              _context.next = 3;
              return axios.post('/vortex/logout_app', {}, {
                withCredentials: true
              });

            case 3:
              window.location.assign('/');

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))
  }, "Logout"))));
};
Logout.propTypes = {
  iconSize: PropTypes.string,
  isLogoutOpen: PropTypes.bool.isRequired,
  setLogoutOpen: PropTypes.func.isRequired,
  showIcon: PropTypes.bool,
  textCaseUpper: PropTypes.bool
};